import { useEffect, useState } from 'react'
import { LazyHelmet } from '../../base'

import { LazyAxios, app_name, catchError, CopyIcon, copyToClipboard, getDate, getFormatedAmount, getToken, InternalError, NoConnection, NoData, NotAuthorized, NotFound404, NotNormalUser, RequestLimt, StartLoading } from '../../base'
import errorName, { base_loading_time, kotak_upi_id, orderStatus, static_img_url, url } from '../../base/Variables'
import { useSelector } from 'react-redux'
import { Rupee } from '../../Componets'

function Payment() {
    const baseUrl = `${url}/api/v1/payment`

    const [loading, setLoading] = useState(null)
    const [error, setError] = useState(null)
    const [orders, setOrders] = useState(null)
    const [totalToPay, setTotalToPay] = useState(0)
    const { user, app_loading } = useSelector((state) => state.appSlice)


    async function getAllPaymentPendingOrders() {
        setLoading(true)
        try {
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.get(`${baseUrl}/paymentPendingOrders/`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (request.data && request.data.data) {
                setOrders(request.data.data)
            }
        }
        catch (error) {
            setError(catchError(error).error_message)
            console.log(catchError(error))
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
            }, [base_loading_time])

            return () => clearTimeout(timeout)
        }
    }

    useEffect(() => {
        getAllPaymentPendingOrders()
    }, [])

    useEffect(() => {
        orders && setTotalToPay(orders.reduce((sum, item) => sum + item.final_total_to_pay, 0))
    }, [orders])

    return (
        <section>
            <LazyHelmet>
                <title>Payment ~ {app_name}</title>
            </LazyHelmet>


            {
                loading || app_loading ? <StartLoading /> :
                    error === errorName.networkError ? <NoConnection /> :
                        error === errorName['404Error'] ? <NotFound404 /> :
                            error === errorName.internalError ? <InternalError /> :
                                error === errorName.notNormalUser ? <NotNormalUser /> :
                                    error && error.includes(errorName.tooManyRequest) ? <RequestLimt time={error} /> :
                                        error === errorName.authenticationError || error === errorName.userNotFound || user === null ? <NotAuthorized /> :
                                            <div className='mainContent'>
                                                <div className='heading h5'>Complete Your Payment</div>
                                                <div className='h7 text-center mb-4 mt-4'>"Final step! Your order is almost ready to be shipped to your doorstep."</div>

                                                {
                                                    orders ?
                                                        <div className='container'>
                                                            <div className='text-center h7'>All your orders with status - </div>
                                                            <div className='text-center pcolor mt-2 mb-5'>{orderStatus['Payment Pending']}</div>

                                                            <div className='row'>
                                                                {
                                                                    orders.map((item, index) => {
                                                                        return <div className='col-12 mb-5' key={index}>
                                                                            <div className='card' style={{ maxWidth: '800px', margin: 'auto', padding: '10px' }}>
                                                                                <div className='row'>
                                                                                    <div className='col-5 col-md-7 col-lg-3'>Order Id : AH-{item.id}</div>
                                                                                    <div className='col-7 col-md-5 col-lg-3'>Order on : {getDate(item.create_at)}</div>
                                                                                    <div className='col-md-7 col-lg-6 truncate-1'>Shop : {item.shop}</div>
                                                                                    <div className='col-md-5 col-lg-3'>Total Items : {item.total_item}</div>
                                                                                    <div className='col-md-7 col-lg-3'>Delivery Charges : {<Rupee amount={item.delivery_charge} />}</div>
                                                                                    <div className='col-md-5 col-lg-6'>Total to Pay : {<Rupee amount={item.final_total_to_pay} />}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    })
                                                                }
                                                            </div>


                                                            <hr />
                                                            <div className='text-center h6 heading'>Payment is pending for above orders</div>

                                                            <div className='mt-4 text-center'>
                                                                {
                                                                    totalToPay && totalToPay > 0 &&
                                                                    <div className='paymentOption d-flex flex-column justify-content-center align-items-center'>
                                                                        <div className='h6 d-flex gap-2 mb-5'>Pay total of <span className='tcolor'>{<Rupee amount={totalToPay} />}</span> </div>
                                                                        <div className='h6'>via UPI ID </div>
                                                                        <div className='h6 pcolor d-flex gap-2 ' onClick={() => copyToClipboard(kotak_upi_id)}>{kotak_upi_id} <CopyIcon className='pcolor' style={{ width: '18px' }} /></div>
                                                                        <div className='divider h6 mt-3 mb-3' style={{ maxWidth: '400px', width: '90%' }}>OR</div>

                                                                        <div className='h6 mb-3'>via QR code </div>
                                                                        <img src={`${static_img_url}/kotak_qr.png`} className='card' style={{ maxWidth: '300px', boxShadow: '0px 0px 5px 0px gray' }} />

                                                                        <div className='divider h6 w-50 mt-5 mb-3' style={{ maxWidth: '400px', width: '90%' }}>OR</div>

                                                                        <a className="secondryButton" href={`${static_img_url}/kotak_qr.png`} target="_blank" rel="noopener noreferrer" download="ahilya_handlooms_qr.png">Download QR code</a>
                                                                    </div>
                                                                }

                                                            </div>
                                                        </div> : <NoData message={'Oops! No orders found with status - " Payment Pending "'} height={'50vh'} />
                                                }

                                            </div>}
        </section>
    )
}

export default Payment